import { useFormikContext } from 'formik'
import React from 'react'
import { ODAppOptions } from '../../../../utils'
export function ODEntityEditorHeader(_a) {
  var title = _a.title,
    populateDevData = _a.populateDevData
  var _b, _c
  var enableDevOptions =
    ((_c = (_b = ODAppOptions) === null || _b === void 0 ? void 0 : _b.FILL_MOCK_DATA),
    _c !== null && _c !== void 0 ? _c : false)
  var setFieldValue = useFormikContext().setFieldValue
  var update = React.useCallback(
    function () {
      if (enableDevOptions && populateDevData) {
        var values_1 = populateDevData()
        Object.keys(values_1).forEach(function (key) {
          // @ts-ignore
          setFieldValue(key, values_1[key])
        })
      }
    },
    [populateDevData, enableDevOptions, setFieldValue]
  )
  var style = enableDevOptions ? { cursor: 'pointer' } : {}
  return React.createElement('strong', { style: style, onClick: update }, title)
}
//# sourceMappingURL=ODEntityEditorHeader.js.map
